document.addEventListener('DOMContentLoaded', () => {
  const bundleRadios = document.querySelectorAll('.bundle-main-selector input[type="radio"]');
  const bundleItems = document.querySelectorAll('.bundle-item');
  const promoTextSpan = document.getElementById('bundle-promo-text');

  if (!bundleRadios.length || !bundleItems.length) return;

  function updateBundleItems(count, variantTitle) {
    // 1. Update visible T-shirt options (enable/disable inputs)
    bundleItems.forEach((item, index) => {
      const inputs = item.querySelectorAll('select, input');
      if (index < count) {
        item.style.display = 'block';
        inputs.forEach(input => input.disabled = false);
      } else {
        item.style.display = 'none';
        inputs.forEach(input => input.disabled = true);
      }
    });

    // 2. Select the native Shopify Variant to update the price securely
    if (variantTitle) {
      // Find Dawn's native variant selectors
      const variantRadios = document.querySelector('variant-radios');
      const variantSelects = document.querySelector('variant-selects');
      
      let variantChanged = false;

      const isMatch = (val) => {
        if (!val) return false;
        const normalizedVal = val.toLowerCase().replace(/[^a-z0-9]/g, '');
        const normalizedTitle = variantTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
        return normalizedVal === normalizedTitle || val.includes(count.toString());
      };

      // If store uses radio buttons for variants
      if (variantRadios) {
         const radios = variantRadios.querySelectorAll('input[type="radio"]');
         radios.forEach(radio => {
           if (isMatch(radio.value)) {
             radio.checked = true;
             radio.dispatchEvent(new Event('change', { bubbles: true }));
             variantChanged = true;
           }
         });
      } 
      
      // If store uses dropdown selects for variants
      if (!variantChanged && variantSelects) {
         const selects = variantSelects.querySelectorAll('select');
         selects.forEach(select => {
           Array.from(select.options).forEach(option => {
             if (isMatch(option.value)) {
               select.value = option.value;
               select.dispatchEvent(new Event('change', { bubbles: true }));
               variantChanged = true;
             }
           });
         });
      }
      
      // Fallback: master hidden select
      let newVariantId = null;
      
      // 3. FORCE SET THE VARIANT ID FOR ADD TO CART
      if (window.bundleVariantIds && window.bundleVariantIds[count.toString()]) {
         newVariantId = window.bundleVariantIds[count.toString()];
         
         // Update ALL inputs and selects named "id" inside product forms!
         // This guarantees Dawn's "Add to Cart" button receives the exactly correct Variant ID!
         const masterInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
         masterInputs.forEach(input => {
            input.value = newVariantId;
            // Also update any data attributes Dawn might use
            if (input.tagName === 'INPUT' && input.type === 'hidden') {
              input.dataset.selectedVariant = newVariantId;
            }
         });
         
         // Try to push it to the URL just in case Dawn relies on URL params
         const url = new URL(window.location.href);
         url.searchParams.set('variant', newVariantId);
         window.history.replaceState({}, '', url.toString());
      } else if (!variantChanged) {
        const masterSelect = document.querySelector('select[name="id"]');
        if (masterSelect) {
           Array.from(masterSelect.options).forEach(option => {
             if (isMatch(option.innerText) || isMatch(option.value)) {
               masterSelect.value = option.value;
               masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
               newVariantId = option.value;
             }
           });
        }
      }

      // Grab the resolved variant ID from the master select (whether Dawn updated it, or we did)
      const finalMasterSelect = document.querySelector('select[name="id"]');
      if (finalMasterSelect) {
        newVariantId = finalMasterSelect.value;
      }

      // 4. INSTANT PRICE UPDATE (Bulletproof fallback using Liquid-injected prices)
      if (window.bundlePrices && window.bundlePrices[count.toString()]) {
         const newPrice = window.bundlePrices[count.toString()];
         const newComparePrice = window.bundleComparePrices ? window.bundleComparePrices[count.toString()] : null;
         
         // Update regular prices (when not on sale)
         document.querySelectorAll('.price__regular .price-item--regular').forEach(el => {
            el.innerHTML = newPrice;
         });
         
         // Update sale price (when on sale)
         document.querySelectorAll('.price__sale .price-item--sale').forEach(el => {
            el.innerHTML = newPrice;
         });
         
         // Update compare at prices
         if (newComparePrice) {
            document.querySelectorAll('.price__sale s.price-item--regular').forEach(el => {
               el.innerHTML = newComparePrice;
            });
            document.querySelectorAll('.price').forEach(el => el.classList.add('price--on-sale'));
         } else {
            document.querySelectorAll('.price').forEach(el => el.classList.remove('price--on-sale'));
         }
      }

    }
  }

  bundleRadios.forEach(radio => {
    radio.addEventListener('change', (e) => {
      if (e.target.checked) {
        // Update promo text
        const label = document.querySelector(`label[for="${e.target.id}"]`);
        if (label && label.dataset.promo && promoTextSpan) {
          promoTextSpan.textContent = label.dataset.promo;
        }
        updateBundleItems(parseInt(e.target.value), e.target.dataset.variantTitle);
      }
    });
  });

  // Initialize on page load
  const checkedRadio = document.querySelector('.bundle-main-selector input[type="radio"]:checked');
  if (checkedRadio) {
    const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
    if (label && label.dataset.promo && promoTextSpan) {
      promoTextSpan.textContent = label.dataset.promo;
    }
    updateBundleItems(parseInt(checkedRadio.value), checkedRadio.dataset.variantTitle);
  } else if (bundleRadios.length > 0) {
    // Default to 2 T-Shirts
    const defaultRadio = Array.from(bundleRadios).find(r => r.value === "2") || bundleRadios[0];
    defaultRadio.checked = true;
    const label = document.querySelector(`label[for="${defaultRadio.id}"]`);
    if (label && label.dataset.promo && promoTextSpan) {
      promoTextSpan.textContent = label.dataset.promo;
    }
    updateBundleItems(parseInt(defaultRadio.value), defaultRadio.dataset.variantTitle);
  }

  // Toggle "Buy it now" button visibility based on gift add-ons
  const giftInputs = document.querySelectorAll('.gift-card__input');
  function toggleBuyNowButton() {
    const anyChecked = Array.from(giftInputs).some(input => input.checked);
    if (anyChecked) {
      document.body.classList.add('hide-dynamic-checkout');
    } else {
      document.body.classList.remove('hide-dynamic-checkout');
    }
  }
  
  if (giftInputs.length > 0) {
    toggleBuyNowButton();
    giftInputs.forEach(input => {
      input.addEventListener('change', toggleBuyNowButton);
    });
  }
});
